import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Typography, Select, FormControl, InputLabel, MenuItem, Button } from "@material-ui/core";
export class EditModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            qualEditModalInfo: this.props.qualEditModalInfo.qualInfo
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.qualEditModalInfo.qualInfo !== this.props.qualEditModalInfo.qualInfo) {
            this.setState({ qualEditModalInfo: this.props.qualEditModalInfo.qualInfo });
        }
    }
    render() {
        const { classes } = this.props;
        return (
            <div>
                <Modal isOpen={this.props.qualEditModalInfo.modalOpen}>
                    <ModalHeader>Edit Qualification Info</ModalHeader>
                    <ModalBody>
                        <div
                            style={{
                                width: "100%"
                            }}
                        >
                            <Typography variant="body2">
                                Edit Image, Expiry Date, Verified, & Registration Number Required
                            </Typography>
                            <Typography variant="body2">
                                for <b>{this.state.qualEditModalInfo.qualTitle}</b>
                            </Typography>
                        </div>

                        <FormControl className={classes.formControl}>
                            <InputLabel>Image Required</InputLabel>
                            <Select
                                value={this.state.qualEditModalInfo.qualImgReq}
                                onChange={event => {
                                    let qualEditModalInfo = this.state.qualEditModalInfo;
                                    qualEditModalInfo.qualImgReq = event.target.value;
                                    this.setState({
                                        qualEditModalInfo
                                    });
                                }}
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel>Expiry Date Required</InputLabel>
                            <Select
                                value={this.state.qualEditModalInfo.qualExpReq}
                                onChange={event => {
                                    let qualEditModalInfo = this.state.qualEditModalInfo;
                                    qualEditModalInfo.qualExpReq = event.target.value;
                                    this.setState({
                                        qualEditModalInfo
                                    });
                                }}
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel>Registraton No. Required</InputLabel>
                            <Select
                                value={this.state.qualEditModalInfo.qualRegReq}
                                onChange={event => {
                                    let qualEditModalInfo = this.state.qualEditModalInfo;
                                    qualEditModalInfo.qualRegReq = event.target.value;
                                    this.setState({
                                        qualEditModalInfo
                                    });
                                }}
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel>Verification Required</InputLabel>
                            <Select
                                value={this.state.qualEditModalInfo.qualVerReq}
                                onChange={event => {
                                    let qualEditModalInfo = this.state.qualEditModalInfo;
                                    qualEditModalInfo.qualVerReq = event.target.value;
                                    this.setState({
                                        qualEditModalInfo
                                    });
                                }}
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </Select>
                        </FormControl>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            <Button
                                onClick={() => {
                                    this.props.setQualEditModalInfo(
                                        {
                                            qualID: "",
                                            qualTitle: "",
                                            qualExpReq: "",
                                            qualImgReq: "",
                                            qualRegReq: "",
                                            qualVerReq: ""
                                        },
                                        false
                                    );
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.props.setQualEditModalInfo(
                                        {
                                            qualID: "",
                                            qualTitle: "",
                                            qualExpReq: "",
                                            qualImgReq: "",
                                            qualRegReq: "",
                                            qualVerReq: ""
                                        },
                                        false
                                    );
                                    this.props.postQualificationUpdateInfo(
                                        this.state.qualEditModalInfo.qualID,
                                        this.state.qualEditModalInfo.qualExpReq,
                                        this.state.qualEditModalInfo.qualImgReq,
                                        this.state.qualEditModalInfo.qualRegReq,
                                        this.state.qualEditModalInfo.qualVerReq
                                    );
                                }}
                            >
                                Submit
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
